interface IApi {
  API_HOST: string
  SCHEDULES_API_HOST: string
  DATASTREAM_API_HOST: string
  DATASTREAM_API_VERSION: string
  GROUPS_API_HOST: string
  PUBLISHING_API_HOST: string
  GATRACKINGID: string
  TYPEAHEAD_API_HOST: string
  TAGS_API_HOST: string
  SPHINX_API_HOST: string
  AUTH: {
    SAFE_LOGIN_URL: string
    STRATEGY: string
    SAFE_LOGOUT_URL: string
  }
  SPHINX_APP_ID: string
}

const sphinxApiHost = process.env.REACT_APP_SPHINX_API_URI || ''
const lapApiHost = process.env.REACT_APP_LAP_API_URI || ''

const localDomain = 'https://api-ci.graphics-sphinx-nonprod.thomsonreuters.com'

const local: IApi = {
  API_HOST: `${localDomain}/graphics`,
  SCHEDULES_API_HOST: `${localDomain}/schedules`,
  DATASTREAM_API_HOST: lapApiHost,
  DATASTREAM_API_VERSION: 'v1',
  GROUPS_API_HOST: `${localDomain}/groups`,
  PUBLISHING_API_HOST: `${localDomain}/publishing`,
  GATRACKINGID: 'G-F8KBL6PEHP',
  TYPEAHEAD_API_HOST: `${localDomain}/typeahead`,
  TAGS_API_HOST: `${localDomain}/tags`,
  SPHINX_API_HOST: sphinxApiHost,
  AUTH: {
    SAFE_LOGIN_URL: 'https://sphinx-dev.int.thomsonreuters.com/auth',
    STRATEGY: '&strategy=manual',
    SAFE_LOGOUT_URL: '/auth/logout/',
  },
  SPHINX_APP_ID: 'sphinx-graphics-ci',
}

const opsDomain = 'https://api-ops.graphics-sphinx-nonprod.thomsonreuters.com'

const ops: IApi = {
  API_HOST: `${opsDomain}/graphics`,
  SCHEDULES_API_HOST: `${opsDomain}/schedules`,
  DATASTREAM_API_HOST: lapApiHost,
  DATASTREAM_API_VERSION: 'v1',
  GROUPS_API_HOST: `${opsDomain}/groups`,
  PUBLISHING_API_HOST: `${opsDomain}/publishing`,
  GATRACKINGID: 'G-F8KBL6PEHP',
  TYPEAHEAD_API_HOST: `${opsDomain}/typeahead`,
  TAGS_API_HOST: `${opsDomain}/tags`,
  SPHINX_API_HOST: sphinxApiHost,
  AUTH: {
    SAFE_LOGIN_URL: 'https://sphinx-dev.int.thomsonreuters.com/auth',
    STRATEGY: '&strategy=manual',
    SAFE_LOGOUT_URL: '/auth/logout/',
  },
  SPHINX_APP_ID: 'sphinx-graphics-ci',
}

const ciDomain = 'https://api-ci.graphics-sphinx-nonprod.thomsonreuters.com'

const ci: IApi = {
  API_HOST: `${ciDomain}/graphics`,
  SCHEDULES_API_HOST: `${ciDomain}/schedules`,
  DATASTREAM_API_HOST: lapApiHost,
  DATASTREAM_API_VERSION: 'v1',
  GROUPS_API_HOST: `${ciDomain}/groups`,
  PUBLISHING_API_HOST: `${ciDomain}/publishing`,
  GATRACKINGID: 'G-F8KBL6PEHP',
  TYPEAHEAD_API_HOST: `${ciDomain}/typeahead`,
  TAGS_API_HOST: `${ciDomain}/tags`,
  SPHINX_API_HOST: sphinxApiHost,
  AUTH: {
    SAFE_LOGIN_URL: 'https://sphinx-dev.int.thomsonreuters.com/auth',
    STRATEGY: '',
    SAFE_LOGOUT_URL: '/auth/logout/',
  },
  SPHINX_APP_ID: 'sphinx-graphics-ci',
}

const citDomain = 'https://api-cit.graphics-sphinx-nonprod.thomsonreuters.com'

const cit: IApi = {
  API_HOST: `${citDomain}/graphics`,
  SCHEDULES_API_HOST: `${citDomain}/schedules`,
  DATASTREAM_API_HOST: lapApiHost,
  DATASTREAM_API_VERSION: 'v1',
  GROUPS_API_HOST: `${citDomain}/groups`,
  PUBLISHING_API_HOST: `${citDomain}/publishing`,
  GATRACKINGID: 'G-3JDZ1HW2GP',
  TYPEAHEAD_API_HOST: `${citDomain}/typeahead`,
  TAGS_API_HOST: `${citDomain}/tags`,
  SPHINX_API_HOST: sphinxApiHost,
  AUTH: {
    SAFE_LOGIN_URL: 'https://sphinx-qaauto.int.thomsonreuters.com/auth',
    STRATEGY: '',
    SAFE_LOGOUT_URL: '/auth/logout/',
  },
  SPHINX_APP_ID: 'sphinx-graphics-cit',
}

const testDomain = 'https://api-test.graphics-sphinx-nonprod.thomsonreuters.com'

const test: IApi = {
  API_HOST: `${testDomain}/graphics`,
  SCHEDULES_API_HOST: `${testDomain}/schedules`,
  DATASTREAM_API_HOST: lapApiHost,
  DATASTREAM_API_VERSION: 'v1',
  GROUPS_API_HOST: `${testDomain}/groups`,
  PUBLISHING_API_HOST: `${testDomain}/publishing`,
  GATRACKINGID: 'G-58T2E2GHG1',
  TYPEAHEAD_API_HOST: `${testDomain}/typeahead`,
  TAGS_API_HOST: `${testDomain}/tags`,
  SPHINX_API_HOST: sphinxApiHost,
  AUTH: {
    SAFE_LOGIN_URL: 'https://sphinx-qa.int.thomsonreuters.com/auth',
    STRATEGY: '',
    SAFE_LOGOUT_URL: '/auth/logout/',
  },
  SPHINX_APP_ID: 'sphinx-graphics-ci',
}

const uatDomain = 'https://api.graphics-sphinx-uat.thomsonreuters.com'

const uat: IApi = {
  API_HOST: `${uatDomain}/graphics`,
  SCHEDULES_API_HOST: `${uatDomain}/schedules`,
  DATASTREAM_API_HOST: lapApiHost,
  DATASTREAM_API_VERSION: 'v1',
  GROUPS_API_HOST: `${uatDomain}/groups`,
  PUBLISHING_API_HOST: `${uatDomain}/publishing`,
  GATRACKINGID: 'G-G5VQLCDW78',
  TYPEAHEAD_API_HOST: `${uatDomain}/typeahead`,
  TAGS_API_HOST: `${uatDomain}/tags`,
  SPHINX_API_HOST: sphinxApiHost,
  AUTH: {
    SAFE_LOGIN_URL: 'https://sphinx-uat.thomsonreuters.com/auth',
    STRATEGY: '',
    SAFE_LOGOUT_URL: '/auth/logout/',
  },
  SPHINX_APP_ID: 'sphinx-graphics-uat',
}

const prodDomain = 'https://api.graphics-sphinx.thomsonreuters.com'

const prod: IApi = {
  API_HOST: `${prodDomain}/graphics`,
  SCHEDULES_API_HOST: `${prodDomain}/schedules`,
  DATASTREAM_API_HOST: lapApiHost,
  DATASTREAM_API_VERSION: 'v1',
  GROUPS_API_HOST: `${prodDomain}/groups`,
  PUBLISHING_API_HOST: `${prodDomain}/publishing`,
  GATRACKINGID: 'G-ZJC91FE1HD',
  TYPEAHEAD_API_HOST: `${prodDomain}/typeahead`,
  TAGS_API_HOST: `${prodDomain}/tags`,
  SPHINX_API_HOST: sphinxApiHost,
  AUTH: {
    SAFE_LOGIN_URL: 'https://sphinx.thomsonreuters.com/auth',
    STRATEGY: '',
    SAFE_LOGOUT_URL: '/auth/logout/',
  },
  SPHINX_APP_ID: 'sphinx-graphics',
}

export enum Stages {
  local = 'local',
  ops = 'ops',
  ci = 'ci',
  cit = 'cit',
  test = 'test',
  uat = 'uat',
  prod = 'prod',
}

const configs: { [key in Stages]: IApi } = {
  local,
  ops,
  ci,
  cit,
  test,
  uat,
  prod,
}

export const STAGE: Stages =
  (process.env.REACT_APP_STAGE as Stages) || Stages.local

if (!(STAGE in Stages)) {
  console.error('Unrecognized stage:', STAGE)
}

export const API = {
  // Add common config values here
  API_VERSION: 'v1',
  ...configs[STAGE],
  HELP_LINK: 'https://thehub.thomsonreuters.com/groups/reuters-graphics-portal',
}
